import { render, staticRenderFns } from "./Image.vue?vue&type=template&id=d228fcc6&scoped=true"
import script from "./Image.vue?vue&type=script&lang=js"
export * from "./Image.vue?vue&type=script&lang=js"
import style0 from "./Image.vue?vue&type=style&index=0&id=d228fcc6&prod&module=true&lang=scss"
import style1 from "./Image.vue?vue&type=style&index=1&id=d228fcc6&prod&lang=scss&scoped=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "d228fcc6",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ListingProductsListItemWishlistBtn: require('/var/www/html/js/productlisting/components/templates/listing/products/ListItem/WishlistBtn.vue').default,BaseImage: require('/var/www/html/js/productlisting/components/common/BaseImage.vue').default,ListingProductsListItemLabelPrimaryDealTag: require('/var/www/html/js/productlisting/components/templates/listing/products/ListItem/label/PrimaryDealTag.vue').default,ListingProductsListItemLabelMattress: require('/var/www/html/js/productlisting/components/templates/listing/products/ListItem/label/Mattress.vue').default,AccountAuthPopup: require('/var/www/html/js/productlisting/components/templates/account/AuthPopup.vue').default})
